import Model from 'flarum/common/Model';
export default class File extends Model {
  baseName() {
    return Model.attribute('baseName').call(this);
  }
  path() {
    return Model.attribute('path').call(this);
  }
  url() {
    return Model.attribute('url').call(this);
  }
  size() {
    return Model.attribute('size').call(this);
  }
  type() {
    return Model.attribute('type').call(this);
  }
  humanSize() {
    return Model.attribute('humanSize').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  uuid() {
    return Model.attribute('uuid').call(this);
  }
  tag() {
    return Model.attribute('tag').call(this);
  }
  hidden() {
    return Model.attribute('hidden').call(this);
  }
  bbcode() {
    return Model.attribute('bbcode').call(this);
  }
  isShared() {
    return Model.attribute('shared').call(this);
  }
  isPrivateShared() {
    return Model.attribute('isPrivateShared').call(this);
  }
  canViewInfo() {
    return Model.attribute('canViewInfo').call(this);
  }
  canHide() {
    return Model.attribute('canHide').call(this);
  }
  canDelete() {
    return Model.attribute('canDelete').call(this);
  }
  apiEndpoint() {
    return '/fof/uploads' + (this.exists ? '/' + this.id() : '');
  }
}
flarum.reg.add('fof-upload', 'common/models/File', File);